export default __webpack_public_path__ + "static/blob11-248c8a3c31fc1f4087bca995c731ab9e.svg";